import { differenceInDays } from 'date-fns/differenceInDays';
import { startOfDay } from 'date-fns/startOfDay';

export function getDiffFromToday(date: Date): number {
  const dateStart = startOfDay(date);
  const today = startOfDay(new Date());

  return differenceInDays(dateStart, today);
}
